import Vue from 'vue'

Vue.filter('striphtml', function (string) {
  return string.replace(/<\/?[^>]+>/gi, ' ')
})
